export const en = {
  common: {
    back: "← Back",
    next: "Next →",
    save: "Save",
    saving: "Saving…",
    cancel: "Cancel",
    creating: "Creating…",
    loading: "Loading…",
    error: "Error",
    optional: "(optional)",
    skip: "Skip",
    open: "Open →",
    signOut: "Sign Out",
    signingOut: "Signing out…",
    approve: "Approve",
    reject: "Reject",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    name: "Name",
    description: "Description",
    amount: "Amount",
    date: "Date",
    title: "Title",
    status: "Status",
    location: "Location",
    notes: "Notes",
    yes: "Yes",
    no: "No",
    project: "Project",
  },

  nav: {
    menu: "Menu",
    pages: "Pages",
    dashboard: "Dashboard",
    projects: "Projects",
    estimates: "Estimates",
    estimator: "Estimator",
    expenses: "Expenses",
    categories: "Categories",
    pricing: "Price Sheet",
    account: "Account",
    signOut: "Sign Out",
    signingOut: "Signing out…",
    homeAria: "ScapeQuote home",
    toggleMenu: "Toggle menu",
  },

  footer: {
    rights: "© {{year}} · All rights reserved",
  },

  login: {
    forgotPassword: "Forgot your password?",
    welcomeBack: "Welcome back",
    signIn: "Sign In",
    email: "Email",
    password: "Password",
    show: "Show",
    hide: "Hide",
    pleaseWait: "Please wait…",
    pleaseEnter: "Please enter your email and password.",
    noAccount: "No account?",
    signUpLink: "Sign up",
    authFailed: "Authentication failed.",
    showPasswordAria: "Show password",
    hidePasswordAria: "Hide password",
  },

  signup: {
    getStarted: "Get started",
    createAccount: "Create Account",
    name: "Name",
    yourFullName: "Your full name",
    email: "Email",
    password: "Password",
    minChars: "Min. 8 characters",
    busy: "Creating…",
    alreadyAccount: "Already have an account?",
    signInLink: "Sign in",
    enterName: "Please enter your name.",
    validEmail: "Please enter a valid email address.",
    passwordLength: "Password must be at least 8 characters.",
    enterEmail: "Please enter a valid email address.",
    enterPassword: "Password must be at least 8 characters.",
    failed: "Sign up failed.",
    confirmPassword: "Confirm password",
    confirmPasswordPh: "Type it again",
    passwordsNoMatch: "The passwords don't match.",
  },

  dashboard: {
    eyebrow: "Dashboard",
    welcome: "Welcome, {{name}}",
    subtitle: "Your snapshot of projects and budgets at a glance.",
    newProject: "+ New Project",
    quickActions: "Quick Actions",
    createProject: "Create Project",
    viewAllProjects: "View All Projects",
    newEstimate: "New Estimate",
    allEstimates: "All Estimates",
    expenseTracker: "Expense Tracker",
    recentProjects: "Recent Projects",
    viewAll: "View all →",
    noProjects: "No projects yet — create your first one.",
    budgetSnapshot: "Budget Snapshot",
    contract: "Contract (approved)",
    pipeline: "Pipeline (drafts & sent)",
    expenses: "Expenses",
    remaining: "Remaining",
    grossProfit: "Gross Profit",
    margin: "Margin",
    noFinancialData: "No financial data yet.",
    loading: "Loading projects…",
    loadingBudget: "Loading…",
    projectProfitTracker: "Project Profit Tracker",
    projectName: "Project",
    fallbackName: "there",
    loadFailed: "Failed to load dashboard data",
    noLocation: "No location",
  },

  projects: {
    eyebrow: "Your work",
    title: "Projects",
    newProject: "+ New Project",
    noProjectsYet: "No projects yet",
    createFirst: "Create your first project to get started.",
    openProject: "Open →",
    loadFailed: "Failed to fetch projects",
    confirmDelete: "Delete \"{{name}}\"?\n\nThis will permanently remove the project and all its estimates, expenses, and change orders.",
    deleteFailed: "Failed to delete project",
    deleteProject: "Delete project",
    deleting: "Deleting…",
  },

  projectWizard: {
    eyebrow: "New Work",
    title: "Create Project",
    step_basics: "Basics",
    step_scope: "Scope",
    step_location: "Location",
    projectName: "Project Name",
    notesOptional: "Notes (optional)",
    notesPlaceholder: "Any details about the project…",
    next: "Next →",
    back: "← Back",
    selectScope: "Select Scope Items",
    itemsSelected_one: "{{count}} item selected: {{items}}",
    itemsSelected_other: "{{count}} items selected: {{items}}",
    projectLocation: "Job Site Address",
    locationNote: "The job site address. It prints on your proposals.",
    createProject: "Create Project",
    creating: "Creating…",
    mustBeLoggedIn: "You must be logged in before creating a project.",
  },

  projectDetail: {
    eyebrow: "Project",
    backToProjects: "← Projects",
    newEstimate: "+ New Estimate",
    estimatesSection: "Estimates",
    noEstimates: "No estimates yet. Create one to get started.",
    changeOrdersSection: "Change Orders",
    noChangeOrders: "No change orders yet.",
    addChangeOrder: "+ Add Change Order",
    cancelAdd: "Cancel",
    newChangeOrderLabel: "New Change Order",
    titlePlaceholder: "e.g. Add retaining wall",
    amountLabel: "Amount ($)",
    amountPlaceholder: "e.g. 2400.00",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Scope of work for this change",
    createChangeOrder: "Create Change Order",
    saving: "Saving…",
    estimatesTotal: "Estimates Total",
    approvedCOs: "Approved COs",
    contractValue: "Contract Value",
    expenses: "Expenses",
    grossProfit: "Gross Profit",
    profitMargin: "Profit Margin",
    trackExpenses: "Track Expenses →",
    created: "Created {{date}}",
    notFound: "Project not found.",
    loadFailed: "Failed to load project",
    confirmDelete: "Delete \"{{name}}\"?\n\nThis will permanently remove the project and all its estimates, expenses, and change orders.",
    deleteProject: "Delete Project",
    deleteFailed: "Failed to delete project",
    statusUpdateFailed: "Failed to update status",
    actionFailed: "Action failed",
    createCoFailed: "Failed to create change order",
    coStatusPending: "Pending",
    coStatusApproved: "Approved",
    coStatusRejected: "Rejected",
  },

  estimateWizard: {
    eyebrow: "Build Your",
    title: "Estimate",
    quickMode: "Quick Mode",
    guidedMode: "Guided (8 Phases)",
    noProjects: "No projects",
    noProjectsNote: "No projects yet —",
    createOneFirst: "create one first",
    estimateTitleLabel: "Estimate Title",
    optional: "(optional)",
    titlePlaceholder: "e.g. Phase 1 – Backyard Patio",
    category: "Category",
    noCategories: "No categories found",
    noCategoriesNote: "Run the category setup SQL in Supabase to enable this.",
    area: "Area (sqft)",
    areaPlaceholder: "e.g. 300",
    state: "State",
    statePlaceholder: "e.g. CA",
    zip: "ZIP Code",
    zipPlaceholder: "e.g. 94103",
    createEstimate: "Create Estimate",
    creating: "Creating…",
    guidedTitlePlaceholder: "e.g. Full Backyard Renovation",
    phase: "Phase {{num}} of {{total}}",
    skip: "Skip",
    nextPhase: "Next Phase →",
    createFullEstimate: "Create Full Estimate",
    phasesConfigured: "Phases Configured",
    resultEyebrow: "Result",
    subtotal: "Subtotal",
    tax: "Tax",
    total: "Total",
    lineItems: "Line Items",
    openPdf: "Open PDF ↗",
    viewProposal: "View Proposal",
    items: "{{count}} items",
    waste: "{{pct}}% waste",
    phases: {
      demo:       "Demo / Site Prep",
      demoHint:   "Demolition, debris removal, grading",
      soil:       "Soil Preparation",
      soilHint:   "Soil amendment, tilling, topsoil",
      irrigation: "Irrigation",
      irrigationHint: "Drip lines, sprinkler systems",
      hardscape:  "Hardscape",
      hardscapeHint: "Patios, walkways, retaining walls",
      planting:   "Planting / Sod",
      plantingHint: "Plants, trees, sod, ground cover",
      mulch:      "Mulch",
      mulchHint:  "Bark, rock, decorative mulch",
      lighting:   "Lighting",
      lightingHint: "Landscape and pathway lighting",
      cleanup:    "Cleanup",
      cleanupHint: "Final clean, haul-away, punch list",
    },
    review: "Review",
    stepOf: "Step {{step}} of {{total}}",
    leaveBlankNote: "Leave anything you don't need blank.",
    estimateCreated: "Estimate created",
    newEstimate: "New Estimate",
    contractType: "Contract type",
    contractLumpSum: "Lump sum",
    contractTimeAndMaterials: "Time & materials",
    lumpSumNote: "One price. No sales tax line — tax on materials is already inside your cost.",
    timeAndMaterialsNote: "Billed on actual time and materials. Sales tax on materials only; labor is never taxed.",
    taxOnMaterialsPct: "Tax on materials ({{pct}}%)",
    salesTaxOnMaterialsPct: "Sales tax on materials ({{pct}}%)",
    materialsCostNote: "For you only: materials cost {{cost}} · markup {{markup}}",
    setTaxRateBefore: "Set your local sales tax rate on",
    priceSheetLink: "the price sheet",
    setTaxRateAfter: "before quoting time and materials.",
    nothingEntered: "Nothing entered yet. Pick a section above and enter quantities.",
    thisSection: "This section",
    previewNote: "Preview. The saved total is calculated on the server from your price sheet.",
    fixQuantities: "Fix the quantities outlined in orange first.",
    quantityAria: "{{item}} quantity",
    calcFromArea: "Calculate from area",
    calcArea: "Area (sq ft)",
    calcDepth: "Depth (in)",
    calcDensity: "Tons / cu yd",
    calcEnterArea: "Enter the area.",
    calcUse: "Use",
    suggestHours: "Suggest hours from plant counts",
    kindMaterial: "Material",
    kindEquipment: "Equipment",
    kindLabor: "Labor",
    priceMaterial: "You pay",
    priceEquipment: "Rental cost",
    priceLabor: "You charge",
  },

  estimatesList: {
    eyebrow: "All Estimates",
    title: "Estimates",
    loading: "Loading…",
    noEstimates: "No estimates yet.",
    filterAll: "All",
    filterDraft: "Draft",
    filterSent: "Sent",
    filterApproved: "Approved",
    filterRejected: "Rejected",
    statusDraft: "Draft",
    statusSent: "Sent",
    statusApproved: "Approved",
    statusRejected: "Rejected",
    totalEstimates: "Total Estimates",
    totalValue: "Total Value",
    approvedValue: "Approved Value",
    pending: "Pending",
    project: "Project",
    date: "Date",
    pdfLink: "PDF ↗",
    proposalLink: "Proposal",
    loadFailed: "Failed to load estimates",
    statusUpdateFailed: "Failed to update status",
    deleteFailed: "Failed to delete estimate",
    renameFailed: "Failed to rename estimate",
    confirmDelete: "Delete \"{{label}}\"? This cannot be undone.",
    estimateNumber: "Estimate #{{num}}",
    noneForFilter: "No {{status}} estimates found.",
    createFirst: "Create your first estimate to get started.",
    titlePlaceholder: "Estimate title…",
    rename: "Rename",
    inclTax: "incl. {{amount}} tax",
    approvedLocked: "Approved estimates are locked — use a change order",
    viewProject: "View Project",
    deleteEstimate: "Delete estimate",
    deleting: "Deleting…",
  },


  expenses: {
    eyebrow: "Spend tracking",
    title: "Expenses",
    project: "Project",
    noProjects: "No projects",
    export: "Export",
    expensesCsv: "Expenses CSV",
    budgetCsv: "Budget CSV",
    budgetSnapshot: "Budget snapshot",
    noProjectSelected: "No project selected",
    createProjectFirst: "No projects yet. Create a project first to track expenses.",
    createProjectFirstReceipts: "Create a project first to upload receipts and add expenses.",
    baseline: "Baseline",
    actual: "Actual",
    remaining: "Remaining",
    byCategory: "By category",
    cat: {
      MATERIAL: "Material",
      LABOR: "Labor",
      EQUIPMENT: "Equipment",
      SUBCONTRACTOR: "Subcontractor",
      OTHER: "Other",
    },
    left: "{{amount}} left",
    noBaseline: "No baseline yet. Approve an estimate to create a budget.",
    logExpense: "Log expense",
    category: "Category",
    vendor: "Vendor",
    vendorPh: "e.g. Home Depot",
    amount: "Amount ($)",
    date: "Date",
    description: "Description (optional)",
    descriptionPh: "Brief description",
    addExpense: "+ Add expense",
    countExpenses: "{{count}} expenses",
    none: "No expenses logged yet.",
    loading: "Loading…",
    categorize: "Categorize",
    edit: "Edit",
    delete: "Delete expense",
    cancel: "Cancel",
    saving: "Saving…",
    saveChanges: "Save changes",
    saveFailed: "Could not save the expense.",
    deleteFailed: "Could not delete the expense.",
    confirmDelete: "Delete \"{{label}}\"? This cannot be undone.",
  },

  receipt: {
    title: "Upload receipt",
    preparing: "Preparing the upload…",
    uploading: "Uploading…",
    reading: "Reading the receipt and creating the expense…",
    processing: "Working…",
    upload: "Upload & create expense",
    noProject: "Pick a project before uploading a receipt.",
    signFailed: "Could not start the upload. Please try again.",
    doneWithAmount: "Receipt saved. Expense draft created for {{amount}}.",
    doneNeedsDetails: "Receipt saved and attached. Add the vendor and amount to finish the expense.",
  },

  demo: {
    banner: "You're exploring the ScapeQuote demo — sample data, shared with everyone, rebuilt every hour.",
    leave: "Leave demo",
  },

  forgot: {
    eyebrow: "Password",
    title: "Reset it",
    intro: "Enter the email you sign in with. We'll send you a link to choose a new password.",
    send: "Send reset link",
    sending: "Sending…",
    sent: "If that email has an account, the link is on its way.",
    sentHint: "It expires in an hour. Check your spam folder if it doesn't arrive in a few minutes.",
    backToSignIn: "Back to sign in",
    failed: "Could not send the reset link. Try again.",
  },

  reset: {
    eyebrow: "Password",
    title: "New password",
    newPassword: "New password",
    confirm: "Confirm new password",
    save: "Save new password",
    saving: "Saving…",
    done: "Password changed. Taking you to sign in…",
    noToken: "This page needs the link from your email.",
    requestNew: "Send me a new link",
    tooShort: "Password must be at least 8 characters.",
    noMatch: "The two passwords don't match.",
    failed: "Could not change the password. Request a new link.",
  },

  proposalSettings: {
    section: "Company & proposals",
    hint: "Printed at the top of every proposal you send.",
    companyName: "Company name",
    companyNamePh: "e.g. Greenline Landscaping",
    license: "Contractor license #",
    licensePh: "e.g. 1098765",
    licenseHint: "California requires your CSLB license number on bids and contracts.",
    email: "Business email",
    emailPh: "e.g. quotes@yourcompany.com",
    emailHint: "Shown on proposals. Leave blank to use the address you sign in with.",
    phone: "Business phone",
    address: "Business address",
    addressPh: "Street, city, state, ZIP",
    validDays: "Proposals valid for (days)",
    terms: "Your terms (optional)",
    termsPh: "e.g. 50% deposit due at signing; balance due on completion.",
    termsHint: "Printed under Terms on every proposal.",
    save: "Save company details",
    saved: "Saved. New proposals will use these details.",
    validDaysRange: "Enter a number of days from 1 to 365.",
  },

  client: {
    saveFailed: "Failed to save",
    section: "Client",
    name: "Client name",
    namePh: "e.g. Maria Garcia",
    phone: "Client phone",
    email: "Client email",
    none: "No client details yet — they print on the proposal under Prepared for.",
    edit: "Edit",
    add: "Add client details",
    save: "Save",
    cancel: "Cancel",
    optional: "Client (optional)",
    optionalHint: "Printed on the proposal. You can add or change this later on the project page.",
  },

  proposalWarnings: {
    noLicense: "Your contractor license number isn't set, so it won't print on this proposal.",
    noCompany: "Your company name isn't set — the proposal will show your personal name.",
    noClient: "This project has no client details, so Prepared for will be blank.",
    fixInAccount: "Add it in Account →",
    fixInProject: "Add them on the project →",
  },

  account: {
    eyebrow: "Settings",
    title: "Account",
    profileSection: "Profile",
    displayName: "Display Name",
    saveNameBtn: "Save Name",
    saving: "Saving…",
    nameUpdated: "Name updated.",
    passwordSection: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    changePasswordBtn: "Change Password",
    changing: "Changing…",
    passwordChanged: "Password changed successfully.",
    passwordsNoMatch: "New passwords do not match.",
    passwordTooShort: "New password must be at least 8 characters.",
    sessionSection: "Session",
    signedInAs: "Signed in as",
    signOut: "Sign Out",
    updateFailed: "Update failed",
    changeFailed: "Password change failed",
    logoSection: "Company Logo",
    logoHint: "PNG or JPEG, max 2 MB. Your logo appears in the header of every PDF estimate you send.",
    noLogo: "No logo",
    uploadLogo: "Upload Logo",
    replaceLogo: "Replace Logo",
    removeLogo: "Remove",
    logoUploading: "Uploading…",
    logoUpdated: "Logo updated. It will appear on your PDF estimates.",
    logoRemoved: "Logo removed.",
    logoTooLarge: "Logo must be under 2 MB.",
    logoWrongType: "Logo must be a PNG or JPEG image.",
    logoUploadFailed: "Logo upload failed",
    namePh: "Your name",
  },

  aiAssistant: {
    eyebrow: "AI Assistant",
    poweredBy: "Powered by Claude — analyze, validate, and generate proposal text.",
    recommend: "Recommend Categories",
    validate: "Validate Estimate",
    generateProposal: "Generate Proposal",
    analyzeProfit: "Analyze Profit",
    loading: "Loading…",
    proposalLabel: "Proposal Text",
    proposalPlaceholder: "AI-generated proposal will appear here…",
    profit_title: "Profit Analysis",
    no_analysis: "No analysis yet.",
    error: "AI error.",
    suggestionsTitle: "Assembly Suggestions",
    ruleOfThumb: "Rule of thumb: {{value}}",
    issuesTitle: "Validation Issues",
    noIssues: "✓ No issues found.",
    suggestion: "Suggestion: {{value}}",
    proposalHint: "Edit before copying to your final proposal.",
    contract: "Contract",
    risks: "Risks",
    severityHigh: "High",
    severityMedium: "Medium",
    severityLow: "Low",
  },

  receiptUpload: {
    eyebrow: "Upload Receipt",
    selectFile: "Select image or PDF",
    upload: "Upload Receipt",
    uploading: "Uploading…",
    success: "Receipt uploaded successfully.",
    error: "Upload failed.",
  },

  locationAutocomplete: {
    placeholder: "Street address, city, ZIP",
  },

  downloadPdf: {
    button: "Download PDF",
    downloading: "Downloading…",
    title: "Download proposal as PDF",
    failed: "Failed to download PDF.",
  },

  home: {
    // Nav
    previewMenu: "Preview",
    previewSamplePages: "Sample Pages",
    previewProjects: "Projects",
    previewEstimates: "Estimates",
    previewExpenses: "Expenses",
    navLogIn: "Log In",
    navGetStarted: "Get Started",
    navGetStartedArrow: "Get Started →",

    // Hero
    heroBadgeTop: "Build Your",
    heroBadgeScript: "perfect estimate",
    heroTagline: "Estimates and proposals for landscapers",
    ctaDemo: "See the live demo",
    ctaDemoBusy: "Opening the demo…",
    ctaDemoFailed: "The demo could not start. Try again in a moment.",
    ctaGetStarted: "Get Started",
    ctaSeeHow: "See How It Works",

    // Features section
    featuresEyebrow: "Everything you need",
    featuresHeading: "Built for the field",
    feature1Title: "Instant Estimates",
    feature1Desc: "Select an assembly, enter square footage, and get a fully itemised cost breakdown in seconds.",
    feature2Title: "Live Pricing",
    feature2Desc: "Regional labor rates and material costs applied automatically based on your ZIP code.",
    feature3Title: "Proposal PDFs",
    feature3Desc: "Generate client-ready proposal documents with one click, straight from any estimate.",
    feature4Title: "Budget Tracking",
    feature4Desc: "Log expenses against projects and watch your gross profit update in real time.",

    // Sample sections
    sampleHeadingProjects: "Organize every job",
    sampleBodyProjects: "Keep all your active and completed landscaping jobs in one place. Each project holds its own estimates, expenses, and proposal PDFs — no more hunting through folders.",
    sampleCtaProjects: "View sample projects",
    sampleHeadingEstimates: "Instant cost breakdowns",
    sampleBodyEstimates: "Pick an assembly, enter square footage and your ZIP code — labor rates and material costs are applied automatically. Download a client-ready PDF with one click.",
    sampleCtaEstimates: "View sample estimates",
    sampleHeadingExpenses: "Track every dollar",
    sampleBodyExpenses: "Log receipts against any project and watch your budget utilisation update in real time. Spot overruns before they become problems.",
    sampleCtaExpenses: "View sample expenses",

    // Final CTA
    ctaBottomEyebrow: "Ready to start?",
    ctaBottomTitle: "Your first estimate is free",
    ctaBottomSub: "Create an account in seconds and start building professional landscaping estimates today. No credit card required.",
    ctaCreateAccount: "Create Free Account",
    ctaSignIn: "Sign In",
    authNavAria: "Account access",
    scrollDownAria: "Scroll down",
    previewProjectsCount: "3 Active Projects",
    previewProject1: "Riverside Backyard Overhaul",
    previewProject2: "Oak Street Front Garden",
    previewProject3: "Sunnyvale HOA Commons",
    previewStatusActive: "Active",
    previewStatusCompleted: "Completed",
    previewStatusEstimating: "Estimating",
    previewEstimateTitle: "Sod Installation",
    previewEstimateMeta: "1,200 sqft · San Jose, CA 95110",
    previewLineSod: "Sod material (1,200 sqft)",
    previewLineSoil: "Soil prep & grading",
    previewLineEdging: "Edging & borders",
    previewLineDelivery: "Delivery",
    previewRecentExpenses: "Recent Expenses",
    previewExpenseDate1: "Mar 18",
    previewExpenseDate2: "Mar 20",
    previewExpenseDate3: "Mar 21",
    ctaDemoWaking: "Waking the server…",
    ctaDemoWakingHint: "The demo server sleeps when nobody is using it. First visit takes about 30 seconds.",
  },
  pricing: {
    eyebrow: "Price Sheet",
    title: "My Rates",
    intro: "Every estimate is priced from this sheet. Materials: what you pay, sales tax included — your markup is added on the quote. Labor: what you charge.",
    restoreDefaults: "Restore Defaults",
    restoring: "Restoring…",
    allSaved: "All saved",
    saveOne: "Save 1 change",
    saveMany: "Save {{count}} changes",
    savedOne: "1 price saved.",
    savedMany: "{{count}} prices saved.",
    nothingChanged: "Nothing has changed.",
    priceInvalid: "\"{{item}}\" needs a price of 0 or more.",
    unitRequired: "\"{{item}}\" needs a unit.",
    loadFailed: "Could not load the price sheet.",
    saveFailed: "Could not save the prices.",
    addRequired: "Name, unit and a price of 0 or more are required.",
    duplicateItem: "There is already an item with that name in this category.",
    itemAdded: "Added \"{{item}}\".",
    addFailed: "Could not add the item.",
    confirmDelete: "Delete \"{{item}}\"? Estimates already made keep it.",
    itemDeleted: "Deleted \"{{item}}\".",
    deleteFailed: "Could not delete the item.",
    confirmReset: "Restore the built-in prices? Items you added are kept.",
    resetDone: "Built-in prices restored.",
    resetFailed: "Could not restore the prices.",
    markupRange: "Markup must be a percentage between 0 and 500.",
    taxRange: "Sales tax must be a percentage between 0 and 20.",
    settingsSaved: "Settings saved.",
    settingsSaveFailed: "Could not save the settings.",
    howYouQuote: "How You Quote",
    materialsMarkup: "Materials markup",
    markupHint: "Added to materials and equipment rentals. Never to labor.",
    salesTax: "Local sales tax (T&M)",
    salesTaxPh: "e.g. 9.375",
    salesTaxHint: "Time-and-materials quotes only, on materials only. Required before quoting T&M.",
    defaultContract: "Default contract type",
    lumpSum: "Lump sum",
    timeAndMaterials: "Time & materials",
    contractHint: "You can change it on each estimate.",
    saveSettings: "Save Settings",
    addItem: "Add item",
    item: "Item",
    price: "Price",
    unit: "Unit",
    yours: "Yours",
    edited: "Edited",
    unsaved: "Unsaved",
    customerPrice: "· customer ${{amount}}",
    unitAria: "{{item}} unit",
    notesAria: "{{item}} notes",
    notesPh: "Optional notes…",
    newItem: "New item",
    newItemPh: "e.g. Japanese Maple – 24\" Box",
    unitPh: "unit",
  },
  categories: {
    eyebrow: "Library",
    intro: "All work categories available in your estimates. Adjust unit prices in your Price Sheet.",
    allCategories: "All Categories",
    emptyState: "No categories yet.",
    emptyStateHint: "Estimate categories will appear here once added to the system.",
    loadError: "Failed to load categories.",
    countAssemblies: "{{count}} assemblies",
    countItems: "{{count}} items",
    countTemplates: "{{count}} templates",
    countLines: "{{count}} lines",
    unitLabel: "Unit",
    wastePct: "Waste: {{pct}}%",
    templates: "Templates",
    tradeDemo: "Demo / Site Prep",
    tradeSoilPrep: "Soil Preparation",
    tradeIrrigation: "Irrigation",
    tradeHardscape: "Hardscape",
    tradeConcrete: "Concrete",
    tradePlanting: "Planting / Sod",
    tradeMulchRock: "Mulch / Rock",
    tradeLighting: "Landscape Lighting (Low Volt)",
    tradeCleanup: "Cleanup",
    tradeLabor: "General Labor",
    tradeOther: "Other",
  },
  assemblies: {
    title: "Assemblies",
    loading: "Loading assemblies…",
    loadError: "Failed to load assemblies or templates. Please try again.",
    emptyState: "No assemblies found.",
    unitFallback: "unit",
    itemsWaste: "{{count}} items • {{pct}}% waste",
    templates: "Templates",
    emptyTemplates: "No templates found.",
    countLines: "{{count}} lines",
  },
  estimateEditor: {
    eyebrow: "Edit Estimate",
    untitled: "Estimate #{{num}}",
    notFound: "Estimate not found",
    loadFailed: "Failed to load estimate",
    saveFailed: "Failed to save",
    repriceFailed: "Failed to reprice",
    checkPricesFailed: "Failed to check prices",
    legacyNote: "This estimate was made before editing was available. Create a new one from your price sheet to make changes.",
    approvedLocked: "Approved and locked. Changes to approved work go through a change order, so the approved budget never shifts.",
    reopenToEdit: "Reopen it as a draft to edit it.",
    changeOrders: "Change Orders",
    newEstimate: "New Estimate",
    allEstimates: "All estimates",
    repriceFromSheet: "Reprice from Sheet",
    saveChanges: "Save Changes",
    savedState: "Saved",
    savedOk: "Estimate saved.",
    savedBackToDraft: "Saved. It's back to Draft — send the customer the updated version.",
    alreadySentNote: "This estimate was already sent. Saving moves it back to Draft so you know to send the customer the new version.",
    repriceHeading: "Prices from your current sheet",
    repriceNoChanges: "Nothing to change — this estimate already matches your current prices.",
    materialsMarkup: "Materials markup",
    noLongerOnSheet: "No longer on your sheet (price kept): {{items}}",
    adjustedPricesKept: "Prices you adjusted for this job and one-off lines are left as they are.",
    apply: "Apply",
    repricedOk: "Repriced from your current price sheet.",
    unsavedWarning: "You have unsaved changes — applying replaces them with the saved estimate, repriced.",
    contractLumpSum: "Lump sum",
    contractTimeMaterials: "Time & materials",
    taxSetupPre: "Set your local sales tax rate on ",
    taxSetupLink: "the price sheet",
    taxSetupPost: " first.",
    catDemo: "Demo / Site Prep",
    catSoilPrep: "Soil Preparation",
    catIrrigation: "Irrigation",
    catHardscape: "Hardscape",
    catConcrete: "Concrete",
    catPlanting: "Planting / Sod",
    catMulchRock: "Mulch / Rock",
    catLighting: "Landscape Lighting",
    catCleanup: "Cleanup",
    catLabor: "Additional Labor",
    kindMaterial: "Material",
    kindEquipment: "Equipment",
    kindLabor: "Labor",
    priceMaterial: "You pay",
    priceEquipment: "Rental cost",
    priceLabor: "You charge",
    oneOffChip: "One-off",
    adjustedChip: "Adjusted for this job (was {{price}})",
    quantity: "Quantity",
    quantityAria: "{{item}} quantity",
    priceAria: "{{item}} price",
    customerPrice: "customer",
    reset: "Reset",
    remove: "Remove",
    removeAria: "Remove {{item}}",
    addToEstimate: "Add to this estimate",
    itemLabel: "Item",
    itemFromSheetPh: "Item from your sheet…",
    itemAlreadyAdded: "That item is already on this estimate.",
    oneOffLine: "One-off line",
    oneOffNamePh: "e.g. Boulder placement",
    oneOffNameAria: "One-off item name",
    kindLabel: "Item type",
    unitPh: "unit",
    unitLabel: "Unit",
    oneOffRequired: "A one-off line needs a name, unit and price.",
    oneOffNote: "A one-off line is for this estimate only — it isn't added to your price sheet.",
    checkQtyPrice: "Check the quantity and price on \"{{item}}\".",
    needsOneItem: "An estimate needs at least one item with a quantity.",
    salesTaxOnMaterials: "Sales tax on materials",
    markupNote: "This estimate's materials markup: {{pct}}%.",
    previewNote: "Preview — save to apply.",
    reviewApprove: "Review & Approve",
    pdfLastSaved: "The PDF shows the last saved version.",
  },
  sample: {
    ariaDemoTabs: "Demo tabs",
    ariaAuth: "Auth",
    backHome: "← Home",
    bannerPreview: "Sample Preview — This is demo data.",
    bannerSignUpLink: "Sign up for the real thing →",
    projectsEyebrow: "Your Work",
    newProject: "+ New Project",
    alertCreateProject: "Sign up to create real projects!",
    alertViewProject: "Sign up to view project details!",
    alertViewEstimates: "Sign up to view estimates!",
    totalProjects: "Total Projects",
    combinedBudget: "Combined Budget",
    statusActive: "Active",
    statusCompleted: "Completed",
    statusEstimating: "Estimating",
    createdOn: "Created {{date}}",
    estimateOne: "{{count}} estimate",
    estimateMany: "{{count}} estimates",
    spentAmount: "{{amount}} spent",
    budgetAmount: "{{amount}} budget",
    budgetUsed: "Budget used",
    ctaProjectsEyebrow: "Ready to track your own projects?",
    projectRiverside: "Riverside Backyard Overhaul",
    projectOakStreet: "Oak Street Front Garden",
    projectSunnyvaleHoa: "Sunnyvale HOA Commons",
    projectPaloAlto: "Palo Alto Drought-Tolerant Redesign",
    projectCampbell: "Campbell Irrigation Upgrade",
    projectRiversideShort: "Riverside Backyard",
    projectPaloAltoShort: "Palo Alto Redesign",
    projectSunnyvaleShort: "Sunnyvale HOA",
    filterAll: "All",
    clientTorres: "Michael & Sandra Torres",
    clientCitySunnyvale: "City of Sunnyvale",
    clientRidgecrestHoa: "Ridgecrest HOA",
    clientChiu: "Dr. Helen Chiu",
    clientEvergreen: "Evergreen Estates LLC",
    locSanJose: "San Jose, CA",
    locSunnyvale: "Sunnyvale, CA",
    locPaloAlto: "Palo Alto, CA",
    locCampbell: "Campbell, CA",
    dateMar012026: "Mar 1, 2026",
    dateMar022026: "Mar 2, 2026",
    dateMar052026: "Mar 5, 2026",
    dateMar062026: "Mar 6, 2026",
    dateMar182026: "Mar 18, 2026",
    dateMar192026: "Mar 19, 2026",
    dateMar202026: "Mar 20, 2026",
    dateMar212026: "Mar 21, 2026",
    dateMar222026: "Mar 22, 2026",
    dateJan142026: "Jan 14, 2026",
    dateFeb282026: "Feb 28, 2026",
    dateDec032025: "Dec 3, 2025",
    estimatesEyebrow: "Cost Breakdowns",
    newEstimate: "+ New Estimate",
    alertBuildEstimates: "Sign up to build real estimates!",
    alertDownloadPdf: "Sign up to download real PDFs!",
    alertEditEstimates: "Sign up to edit estimates!",
    estimateMeta: "{{sqft}} sqft · ZIP {{zip}} · Created {{date}}",
    total: "Total",
    downloadPdf: "Download PDF",
    allEstimates: "All Estimates",
    combined: "Combined",
    supportedAssemblies: "Supported Assemblies",
    ctaEstimatesBody: "Sign up to build estimates with your own projects, assemblies, and ZIP codes.",
    asmSod: "Sod Installation",
    asmDripSystem: "Drip Irrigation System",
    asmDgPathway: "Decomposed Granite Pathway",
    asmDripIrrigation: "Drip Irrigation",
    asmHardscape: "Hardscape / DG",
    asmMulch: "Mulch & Groundcover",
    asmTreeShrub: "Tree & Shrub",
    asmTurfRemoval: "Turf Removal",
    liSodMaterial: "Sod material (Bermuda blend)",
    liSoilPrep: "Soil prep & finish grading",
    liConcreteEdging: "Concrete edging & borders",
    liDeliveryAllocated: "Delivery (allocated)",
    liDripEmitters: "Drip emitters & tubing (1,200 lf)",
    liBackflow: "Backflow preventer & filter",
    liTimer: "Timer / controller unit",
    liInstallLabor: "Installation labor",
    liDgMaterial: "Decomposed granite (3\" depth)",
    liWeedBarrier: "Weed barrier fabric",
    liSteelEdging: "Steel edging (140 lf)",
    liLaborCompact: "Labor — install & compact",
    expensesEyebrow: "Spend Tracking",
    logExpense: "+ Log Expense",
    alertLogExpenses: "Sign up to log real expenses!",
    expenseOne: "{{count}} expense",
    expenseMany: "{{count}} expenses",
    receipt: "Receipt",
    totalLogged: "Total Logged",
    transactionsCount: "{{count}} transactions",
    budgetVsActual: "Budget vs. Actual",
    byCategory: "By Category",
    ctaExpensesBody: "Log expenses with receipt photos, filter by project, and export reports.",
    ctaStartTracking: "Start Tracking →",
    catMaterials: "Materials",
    catSubcontractor: "Subcontractor",
    catEquipment: "Equipment",
    catDelivery: "Delivery",
    vendorSodSource: "SodSource Inc.",
    vendorManuelGrading: "Manuel's Grading Co.",
    vendorLowes: "Lowe's – Milpitas",
    vendorHomeDepot: "Home Depot",
    vendorPeninsula: "Peninsula Landscape Supply",
    vendorBayAreaSteel: "Bay Area Steel Edging",
    vendorFastFlatbed: "Fast Flatbed Delivery",
    vendorPacificCoast: "Pacific Coast Irrigation",
  },
  proposalViewer: {
    title: "Proposal",
    noEstimateId: "No estimate ID provided.",
    approvedLocked: "Approved and locked. Changes to approved work go through a change order.",
    rejected: "Rejected. Reopen it as a draft to approve it.",
    approveEstimate: "Approve Estimate (Lock & Create Budget)",
    approving: "Approving…",
    editFirst: "Edit first",
    finalized: "Estimate finalized and baseline created. You can now see it on the Expenses page.",
    approveFailed: "Failed to approve estimate.",
    loadFailed: "Could not load this proposal.",
    loading: "Loading proposal…",
    openNewTab: "Open in new tab",
    cantSee: "Can't see it?",
  },
  openPdf: {
    opening: "Opening…",
    failed: "Failed to open PDF.",
    title: "Open proposal PDF in a new tab",
  },
  catalog: {
    item: {
      demoLabor: "Demo Labor",
      haulAway: "Haul Away",
      grading: "Grading",
      topsoil: "Topsoil",
      soilAmendment: "Soil Amendment",
      soilPrepLabor: "Soil Prep Labor",
      dripLine: "Drip Line",
      sprinklerHead: "Sprinkler Head",
      irrigationLabor: "Irrigation Labor",
      pavers: "Pavers",
      baseRock: "Base Rock (Class II)",
      sandBase: "Sand Base",
      geotextile: "Geotextile Fabric",
      edgeRestraint: "Edge Restraint",
      polymericSand: "Polymeric Sand",
      plateCompactor: "Plate Compactor Rental",
      hardscapeLabor: "Hardscape Labor",
      concrete: "Concrete",
      formLabor: "Form Labor",
      concreteLabor: "Concrete Labor",
      sod: "Sod",
      groundcoverFlat: "Groundcover – Flat",
      plant1Gal: "Plant – 1 Gal",
      plant5Gal: "Plant – 5 Gal",
      plant15Gal: "Plant – 15 Gal",
      tree24Box: "Tree – 24\" Box",
      tree36Box: "Tree – 36\" Box",
      plantingLabor: "Planting Labor",
      woodMulch: "Wood Mulch",
      crushedRock: "Crushed Rock",
      decorativeRock: "Decorative Rock",
      mulchInstallLabor: "Mulch Install Labor",
      lightFixture: "Light Fixture",
      lowVoltWire: "Low Volt Wire",
      transformer: "Transformer",
      lightingLabor: "Lighting Labor",
      finalCleanupLabor: "Final Cleanup Labor",
      debrisRemoval: "Debris Removal",
      generalLabor: "General Labor",
      foreman: "Foreman",
      equipmentOperator: "Equipment Operator",
    },
  },
  category: {
    demo: "Demo / Site Prep",
    soilPrep: "Soil Preparation",
    irrigation: "Irrigation",
    hardscape: "Hardscape",
    concrete: "Concrete",
    planting: "Planting / Sod",
    mulchRock: "Mulch / Rock",
    lighting: "Landscape Lighting",
    cleanup: "Cleanup",
    labor: "Additional Labor",
    other: "Other",
  },
  categoryHint: {
    demo: "Demolition, haul-away, grading",
    soilPrep: "Topsoil, amendment, tilling",
    irrigation: "Drip line, sprinkler heads",
    hardscape: "Pavers, base, edging",
    concrete: "Flatwork, forms",
    planting: "Plants by container size, trees, sod",
    mulchRock: "Bark, crushed and decorative rock",
    lighting: "Fixtures, wire, transformer",
    cleanup: "Final clean, debris removal",
    labor: "Crew hours not covered above",
    other: "Anything not covered above",
  },
};

// Recursive string-record type — allows any language to satisfy the shape
// without being locked to the exact English literal strings.
export type DeepStrings = { [K: string]: string | DeepStrings };
export type Translations = DeepStrings;
